var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransaction1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1E899",
    d: "M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1E899",
    d: "M6.5 9h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1C7.33 8 8 7.33 8 6.5S7.33 5 6.5 5h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1a2.5 2.5 0 0 1 0 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1E899",
    d: "M10.5 7h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5c.28 0 .5.22.5.5s-.22.5-.5.5m0-2h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5c.28 0 .5.22.5.5s-.22.5-.5.5m-3 7c-.16 0-.32-.08-.42-.22l-2-3a.498.498 0 0 1 .83-.55l2 3c.15.23.09.54-.14.69c-.09.06-.18.08-.28.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction1);
export default __webpack_public_path__ + "static/media/transaction1.16e6aa8b1265f84b2de7f0530e807dd3.svg";
export { ForwardRef as ReactComponent };